<app-header (clickMenu)="sidenavDrawer.toggle()"></app-header>
<mat-drawer-container
  class="auth-content"
  [hasBackdrop]="true">
  <mat-drawer
    #sidenavDrawer
    [mode]="'over'">
    <app-sidenav
      [menus]="menus"
      (clickMenu)="sidenavDrawer.toggle()">
    </app-sidenav>
  </mat-drawer>
  <mat-drawer-content class="auth-page">
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>

